import axios from 'axios';

export const getWatermark = params => {
  return axios.get('/yongpai-system/api/ads/watermark',{params : params});
};



// WEBPACK FOOTER //
// ./src/api/watermark/index.js